<template>
	<div>
		<vs-table search stripe :data="products_by_provider" max-items="15" pagination>
			<template slot="header">
				<h1>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
						Compras<br>
					</vs-col>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
						<vs-button @click="createShopPrompt()" radius color="success" type="border" icon="add"></vs-button>
					</vs-col>
					<vs-prompt @cancel="val=''" @accept="createShop" :active.sync="activePrompt2" title="Crear Compra" :is-valid="validName">
						<div class="con-exemple-prompt">
							<vs-select class="selectExample" label="Producto" v-model="idProduct">
								<vs-select-item size="small" :key="index" :value="item.id" :text="item.brand" v-for="(item,index) in products"/>
							</vs-select>
							<vs-col class="textDate" type="flex" vs-justify="center" vs-align="center" vs-w="6">
								<div style="margin-left: 20px;">
									Fecha de elaboración:
								</div>
							</vs-col>
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
								<datepicker label="Fecha de elaboración" format="dd-MM-yyyy" placeholder="Select Date" v-model="elaboration_date"></datepicker>
							</vs-col>
							<vs-col class="textDate" type="flex" vs-justify="center" vs-align="center" vs-w="6">
								<div style="margin-left: 30px;">
									Fecha de expiración:
								</div>
							</vs-col>
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
								<datepicker :disabledDates="disabledDates" label="Fecha de expiración" format="dd-MM-yyyy" placeholder="Select Date" v-model="expiration_date"></datepicker>
							</vs-col>
							<!-- <vs-input size="small" label="Fecha de elaboración" v-model="elaboration_date"/>
							<vs-input size="small" label="Fecha de expiración" v-model="expiration_date"/> -->
							<vs-input-number size="medium" label="Cajas" v-model="boxes"/>
							<vs-input-number size="medium" label="Precio de compra Unitario" v-model="purchase_price_unit"/>
							<vs-input-number size="medium" label="Porcentaje de precio de venta" v-model="sale_price" min="0" max="100"/>
							<vs-input size="small" label="Observación" v-model="observation"/>
							<vs-alert :active="!validName" color="danger" icon="new_releases" class="emptyWarning">
								Completar campos
							</vs-alert>
						</div>
					</vs-prompt>
					
				</h1>
			</template>
			<template slot="thead">
				
				<vs-th>
					Producto
				</vs-th>
				<vs-th >
					Cajas
				</vs-th>
				<vs-th>
					Total de compra
				</vs-th>
				<vs-th>
					Días vigentes
				</vs-th>
				<vs-th>
					Editar
				</vs-th>
				
				
			</template>

			<template slot-scope="{data}">
				<vs-tr :state="data[indextr].inventory==0 ?'dark':validateDate(data[indextr].expiration_date) == 0 ?'danger':null" :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].productData.brand">
						{{data[indextr].productData.brand}}
					</vs-td>

					<vs-td :data="data[indextr].boxes">
						{{data[indextr].inventory}}/{{data[indextr].boxes}}
					</vs-td>

					<vs-td :data="data[indextr].final_total">
						L. {{data[indextr].final_total}}
					</vs-td>

					<vs-td :data="data[indextr].observation">
						<div v-if="data[indextr].inventory==0">
							N/A
						</div>
						<div v-else>
							{{ getHumanDate(data[indextr].expiration_date) }}
						</div>
					</vs-td>

					<vs-td :data="data[indextr].id">
						<vs-button  @click="editShopPrompt(tr)" vs-type="gradient" size="small" color="success" icon="edit" :disabled="data[indextr].inventory==0"></vs-button>
						<vs-prompt @cancel="val=''" @accept="editShop" :active.sync="activePrompt" title="Editar Compra">
							<div class="con-exemple-prompt">						
								<vs-select class="selectExample" label="Producto" v-model="idProduct">
									<vs-select-item size="small" :key="index" :value="item.id" :text="item.brand" v-for="(item,index) in products"/>
								</vs-select>
								<vs-col class="textDate" type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<div style="margin-left: 20px;">
										Fecha de elaboración:
									</div>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<datepicker label="Fecha de elaboración" format="dd-MM-yyyy" placeholder="Select Date" v-model="elaboration_date"></datepicker>
								</vs-col>
								<vs-col class="textDate" type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<div style="margin-left: 30px;">
										Fecha de expiración:
									</div>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<datepicker :disabledDates="disabledDates" label="Fecha de expiración" format="dd-MM-yyyy" placeholder="Select Date" v-model="expiration_date"></datepicker>
								</vs-col>
								<vs-input-number size="medium" label="Cajas" v-model="boxes"/>
								<vs-input-number size="medium" label="Precio de compra Unitario (Lps)" v-model="purchase_price_unit"/>
								<vs-input-number size="medium" label="Porcentaje de precio de venta (%)" v-model="sale_price" min="0" max="100"/>
								<vs-input size="small" label="Observación" v-model="observation"/>
							</div>
						</vs-prompt>
					</vs-td>
					<!-- <vs-td :data="data[indextr].expiration_date">
						{{ getHumanDate(data[indextr].expiration_date) }} 
					</vs-td> -->
					<template class="expand-user" slot="expand">
							<vs-list>
								<div>
									<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
                                        <vs-list-item icon="note" title="Registro Sanitario" :subtitle="tr.productData.health_record"></vs-list-item>
										<vs-list-item icon="save_alt" title="Peso total (Kg)" :subtitle="tr.weight_by_boxes.toString()"></vs-list-item>
										<vs-list-item icon="aspect_ratio" title="Volumen (mts3)" :subtitle="tr.productData.volumen.toString()"></vs-list-item>
										<vs-list-item icon="apps" title="Cantidad de cajas" :subtitle="tr.boxes.toString()"></vs-list-item>
                                        <vs-list-item icon="attach_money" title="Precio por caja (Lps)" :subtitle="tr.price_by_box.toString()"></vs-list-item>
                                        <vs-list-item icon="attach_money" title="Precio de venta (%)" :subtitle="tr.sale_price.toString()"></vs-list-item>
                                        <vs-list-item icon="announcement" title="Observación" :subtitle="tr.observation"></vs-list-item>
									</vs-col>
									<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
                                        <vs-list-item icon="save_alt" title="Peso individual (Kg)" :subtitle="tr.productData.weight.toString()"></vs-list-item>
										<vs-list-item icon="save_alt" title="Peso por caja (Kg)" :subtitle="tr.productData.weight_by_box.toString()"></vs-list-item>
										<vs-list-item icon="ballot" title="Cantidad por caja" :subtitle="tr.productData.quanty_by_box.toString()"></vs-list-item>
                                        <vs-list-item icon="view_module" title="Total de unidades" :subtitle="tr.total_by_units.toString()"></vs-list-item>
                                        <vs-list-item icon="attach_money" title="Precio individual (Lps)" :subtitle="tr.purchase_price_unit.toString()"></vs-list-item>
                                        <vs-list-item icon="date_range" title="Fecha de elaboración" :subtitle="getHumanDate(tr.elaboration_date)"></vs-list-item>
										<vs-list-item icon="date_range" title="Registro de compra" :subtitle="getHumanDate(tr.created_at)"></vs-list-item>
									</vs-col>
								</div>
										

							</vs-list>
							<div class="con-btns-user">
								<div>
									<vs-button @click="openConfirm(tr.id)" vs-type="flat" size="medium" color="danger" icon="delete_sweep" :disabled="data[indextr].inventory==0"></vs-button>
								</div>
							</div>
					</template>
				</vs-tr>
			</template>

    </vs-table>
	<!-- <pre>{{ selected }}</pre> -->

	</div>
</template>

<script>

import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
	data(){
		return{
			products_by_provider : [],
			val:'',
			activePrompt:false,
			activePrompt2:false,
			activeConfirm:false,
			idShop: null,
			idProduct: "",
			elaboration_date: "",
			expiration_date: "",
			purchase_price_unit: null,
			price_by_box: null,
			boxes: "",
			total_by_units: null,
			weight_by_boxes: null,
			volumen: null,
			final_total: null,
			sale_price: null,
			observation: "",
			productData: "",
			products: "",
			config:"",
			disabledDates: {
				// to: new Date(new Date().getFullYear(), new Date().getMonth()+1, new Date().getDay()+15), // Disable all dates up to specific date
				to: new Date(moment().add(46, 'days').format('YYYY,MM,DD')),
				from: new Date(moment().add(5, 'years').format('YYYY,MM,DD')),
				// from: new Date(new Date().getFullYear()+5, new Date().getMonth(), 1), // Disable all dates after specific date
			},
		}
	},
	components: {
		Datepicker
	},
	computed:{
		validName(){
			// return (this.boxes.toString().length > 0 &&  this.elaboration_date.length > 0 && this.expiration_date.length > 0 && this.purchase_price_unit.toString().length > 0 && this.sale_price.toString().length > 0 && this.observation.length > 0)
			return (this.idProduct.toString().length > 0 && this.boxes.toString().length > 0 &&  this.elaboration_date.toString().length > 0 && this.expiration_date.toString().length > 0 && this.purchase_price_unit.toString().length > 0 && this.sale_price.toString().length > 0 && this.observation.length > 0)	
		}
	},
	methods: {
		getShops(){
			const path = '/products_by_provider/'
			this.$http.get(path).then((response) => {
				this.products_by_provider = response.data
				console.log(this.products_by_provider)
			})
			.catch((error) => {
				console.log(error)
			})

			const path2 = '/product/'
			this.$http.get(path2).then((response) => {
				this.products = response.data
				console.log(this.products)
			})
			.catch((error) => {
				console.log(error)
			})
		},
        editShop(){
			const path = `/products_by_provider/${this.idShop}/` 
			this.$http.patch(path, {
				product: this.idProduct,
				boxes: this.boxes,
				inventory: this.boxes,
				elaboration_date: this.elaboration_date,
				expiration_date: this.expiration_date,
				purchase_price_unit: this.purchase_price_unit,
				sale_price: this.sale_price,
				observation: this.observation
			})
			.then((response) => {
				console.log(response.data)
				this.getShops()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:'Actualización de los datos de la compra'
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser editado'
				})
			});	
		},
		deleteShop(){
			const path = `/products_by_provider/${this.idShop}/` 
			this.$http.delete(path).then((response) => {
				console.log(response.data)
				this.getShops()
				this.$vs.notify({
					color:'danger',
					title:'Registro eliminado',
					text:`El registro fue eliminado correctamente`
				})
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser eliminado'
				})
			})
			
		},
        createShop(){
			const path = `/products_by_provider/`
			var infoProduct = this.products.filter(({id})=>(this.idProduct == id))
			console.log(infoProduct[0])
			this.$http.post(path, {
				product: this.idProduct,
				boxes: this.boxes,
				inventory: this.boxes,
				elaboration_date: this.elaboration_date,
				expiration_date: this.expiration_date,
				purchase_price_unit: this.purchase_price_unit,
				sale_price: this.sale_price,
				price_by_box: this.purchase_price_unit * infoProduct[0].quanty_by_box,
				total_by_units: this.boxes * infoProduct[0].quanty_by_box,
				weight_by_boxes: this.boxes * infoProduct[0].weight_by_box,
				// volumen: this.boxes * infoProduct[0].high * infoProduct[0].long * infoProduct[0].width,
				final_total: this.purchase_price_unit * this.boxes * infoProduct[0].quanty_by_box,
				observation: this.observation
			})
			.then((response) => {
				console.log(response.data)
				this.getShops()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:`Creación de la compra`
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'La compra no pudo ser creada'
				})
			});
		},
		openConfirm(id){
			this.idShop = id,
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: `Confirmar`,
				text: `¿Desea eliminar la compra?`,
				accept:this.deleteShop,
				acceptText:'Aceptar',
				cancelText:'Cancelar',
			})
		},
		editShopPrompt(id){
			this.idProduct = id["product"];
			this.idShop = id["id"];
			this.activePrompt = true;
			this.boxes = id["boxes"];
			this.elaboration_date = id["elaboration_date"];
			this.expiration_date = id["expiration_date"];
			this.purchase_price_unit = id["purchase_price_unit"];
			this.sale_price = id["sale_price"];
			this.observation= id["observation"];
		},
        createShopPrompt(){
			this.idProduct = "";
			this.activePrompt2 = true;
			this.boxes = "";
			this.elaboration_date = moment().format("YYYY-MM-DD") + 'T00:00:00Z';
			this.expiration_date = moment().add(46, 'days').format("YYYY-MM-DD") + 'T12:00:00Z';
			this.purchase_price_unit = "";
			this.sale_price = "";
			this.observation= "";
		},
        
		getHumanDate : function (date) {
			// return moment(date, 'YYYY-MM-DDTh:mm').format('DD/MM/YYYY, h:mm a');
            moment.locale('es');
			return moment(date, 'YYYY-MM-DDTh:mm').fromNow();
        },
        validateDate : function (date) {
			// return moment(date, 'YYYY-MM-DDTh:mm').format('DD/MM/YYYY, h:mm a');
            var exp_date = moment().add(45, 'days').calendar();
            exp_date = moment(exp_date,'DD/MM/YYYY').format('YYYY-MM-DD');
            // console.log(exp_date)
            var isafter = moment(date, 'YYYY-MM-DD').isAfter(exp_date); 
            // console.log(isafter);
            return isafter
            // console.log(isafter);
        },
	},
	created(){
		this.getShops()
	}
}
</script>

<style lang="stylus">
.con-exemple-prompt
	padding 1px;
	padding-bottom 1px;
	.vs-input
		width 95%
		margin-top 1px;
.emptyWarning{
	width 90%;
	margin-top:10px;
}
.selectExample{
	width 95%
	margin-top 1px;
}
.vs-input-number{
	justify-content left;
	background white;
	margin-top 10px;
}
.vdp-datepicker input{
	width 90%
	margin-top 10px;
}
.textDate{
	margin-top 14px;
}
.tr-table-state-dark{
	opacity 0.4;
}
</style>